import MojitoCore from 'mojito/core';
import { CONTAINERS_COLLECTION_NAME } from 'services/promotions/types.js';
const DataProvider = MojitoCore.Services.DataProvider;

/**
 *
 * Class offering the possibility to link to promotion containers.
 *
 * @class PromotionContainersProvider
 * @extends Mojito.Core.DataProviders.DataProvider
 * @memberof Mojito.Services.Promotions
 */
class PromotionContainersProvider extends DataProvider {
    init(languageCode) {
        this.addLocalizedCollection(CONTAINERS_COLLECTION_NAME, languageCode);
    }

    /**
     * Link to a promotion container entity.
     *
     * @param {string} entityId - The `${containerId}|${channel}` identifier to link to (example: 286|desktop_auth).
     * @param {Function} setter - Function called when the requested data is updated.
     *
     * @returns {object} Subscription that must be disposed when no longer needed.
     *
     * @function Mojito.Services.Promotions.PromotionContainersProvider#subscribeToEntity
     */
    subscribeToEntity(entityId, setter) {
        return super.subscribeToEntity(entityId, setter, CONTAINERS_COLLECTION_NAME);
    }
}

PromotionContainersProvider.COLLECTION_NAME = CONTAINERS_COLLECTION_NAME;

export default new PromotionContainersProvider();
